<template>
    <span class="d-flex row-balance-visible">
        <button class="btn-action" @click="toggleShow()">
            <span :class="show_balance?'d-block':'d-none'">
                <i class="far fa-eye-slash pl-2 pr-2"></i>
            </span>
            <span :class="show_balance?'d-none':'d-block'">
                <i  class="far fa-eye pl-2 pr-2"></i>
            </span>
        </button>
        {{currency}} <span v-if="show_balance">{{ getPrice(balance) }}</span> <span v-else>*****</span>
    </span>
</template>

<script>
import Account from '@/services/Account';
import Global from '@/services/Global';
export default{
    data(){
        return{
            show_balance:false
        }
    },
    props:['currency','userNo'],
    methods:{
        getPrice(amount){
            return Global.addCommas(amount);
        },
        toggleShow(){
            this.show_balance = !this.show_balance;
        }
    },
    mounted(){
        Account.getBalance({
            "userNo":this.userNo,
            "ccy":this.currency
        }).then((response)=>{
            let data = response.data.data.data;
            this.balance=data.availableBal;
        });
    }
}
</script>

<style>
.row-balance-visible{
    min-width: 125px;
    padding: 0 10px;
    border-right: 1px solid #D1D4D7;
}
.row-balance-visible:last-child{
    border: unset !important;
}
</style>
